export enum WorkflowEditorTemplateBlockTypeEnum {
  EMAIL = "email",
  SMS = "sms",
}
